export const helpRoutes = [
  {
    path: '/help',
    name: 'help',
    component: () => import(/* webpackChunkName: "help" */ './Help.vue'),
    redirect: '/help/q',
    children: [
      {
        path: 'q',
        name: 'help-list',
        component: () => import(/* webpackChunkName: "help-list" */ './components/HelpList.vue')
      },
      {
        path: 'forgot-username',
        name: 'forgot-username',
        component: () =>
          import(/* webpackChunkName: "forgot-username" */ './components/ForgotUsername.vue')
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () =>
          import(/* webpackChunkName: "forgot-password" */ './components/ForgotPassword.vue')
      },
      {
        path: 'password-reset/:code',
        name: 'password-reset',
        component: () =>
          import(/* webpackChunkName: "password-reset" */ './components/ResetPassword.vue')
      }
    ]
  },
  {
    path: '/user-guides',
    name: 'user-guides',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "user-guides" */ './UserGuides.vue')
  }
];
